import z from "zod"

export const GmailIntegrationCallbackSchema = z.object({
  code: z.string(),
})

export const GmailIntegrationParams = z.object({
  id: z.string().transform(BigInt),
})
